module.exports = __webpack_public_path__ + "22807a201e28d6334b61a8465b962d4b.svg";